import * as types from 'constants/actionTypes';

export function updateUser(user) {
  return function (dispatch) {
    return dispatch({
      type: types.UPDATE_USER,
      user
    });
  };
}